import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function hideReturnNumberInput(): RootActionTypes {
  return standardAction(ActionTypes.HIDE_RETURN_NUMBER_INPUT);
}
